import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { CreateResourceApi } from '../../../reduxToolkit/Cards/CardsApi';
import { UploadImage } from '../../../reduxToolkit/ShareSlice/shareApi';
import { CustomTextField } from '../../../components/CustomTextField';
import { FILE_TYPE } from '../../../Helpers/fileType';
import CustomModal from '../../../components/Modal/CustomModal';
import {getPhotoPicker, PHOTO_PICKER_MODEL} from '../../../components/PhotoPicker/SubComponent/Models/Models';
import {ACTION_MODEL} from '../../../Helpers/ActionModel';
import CustomPhotoPicker from '../../../components/PhotoPicker/CustomPhotoPicker';
import noLogo from '../../../assets/defaultImages/no-logo.png';
import {errorMsg} from '../../../Apis/functions';
import {TABLES} from "../../../Apis/Tables";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const AddResource = ({ open, onClose, onUpdated }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [resourceName, setResourceName] = useState('');
    const [photoPicker, setPhotoPicker] = useState({ ...PHOTO_PICKER_MODEL, preview: noLogo });
    const [emptyFields, setEmptyFields] = useState(false);
    // Resets the resource name, clears the selected image, and sets empty fields flag when the modal or dialog is opened.
    useEffect(() => {
        setResourceName('');
        handleClearPhoto();
        setEmptyFields(false);
    }, [open]);
    // Clears the selected image by setting the state to null.
    const handleClearPhoto = () => {
        setPhotoPicker({...PHOTO_PICKER_MODEL, preview: noLogo});
    };
    // Initiates the upload process for the image if all conditions are met.
    const handelUploadImageAction = () => {
        setEmptyFields(true);
        let selectedImage = getPhotoPicker(photoPicker);
        if (resourceName !== '' && selectedImage !== null) {
            const body = {
                name: resourceName,
            };
            dispatch(CreateResourceApi(body)).then(({payload: {data: { data, success, code }}}) => {
                    if (success === true) {
                        let formData = new FormData();
                        formData.append('id', data?.id);
                        formData.append('option', TABLES.RESOURCES);
                        formData.append('file', selectedImage);
                        dispatch(UploadImage(formData)).then(
                            ({
                                 payload: {
                                     data: { success },
                                 },
                             }) => {
                                if (success === true) {
                                    toast.success(t('has_been_created_successfully'));
                                    onUpdated();
                                    onClose();
                                } else {
                                    errorMsg(code)
                                }
                            },
                        );
                    }
                },
            );
        } else if (selectedImage === null) {
            toast.warn(t('please_select_an_image'));
        }
    };

    return (
        <CustomModal
            title='create'
            size='md'
            buttonCancelText='cancel'
            buttonConfirm='confirm'
            cancelButton={true}
            confirmButton={true}
            onHide={onClose}
            onConfirm={() => {
                setEmptyFields(true);
                if (resourceName.trim() === '') {
                    toast.warn(t('please_fill_all_fields'));
                    return;
                }
                handelUploadImageAction();
            }}
            show={open}
        >
            <Box className='form-field required-data mt-2'>
                <CustomTextField
                    size='small'
                    fullWidth
                    label='name'
                    id='txt_ar_name'
                    value={resourceName}
                    onChange={(e) => setResourceName(e.target.value)}
                    inputProps={{ maxLength: 128 }}
                    required={true}
                    emptyFields={emptyFields && resourceName === ''}
                    trans='name'
                />
            </Box>

            <div className='row'>
                <div className='d-flex justify-content-center align-items-center'>
                    <CustomPhotoPicker
                        id='file_input'
                        photoPicker={photoPicker}
                        setPhotoPicker={setPhotoPicker}
                        actionModel={ACTION_MODEL.CREATE}
                        accept={{ ...FILE_TYPE.IMAGE }}
                        classWith={'w-100'}
                        titleInput='choose_or_drag_your_image_here'
                        required={true}
                    />
                </div>
            </div>
        </CustomModal>
    );
};

export default AddResource;
